/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".brand[_ngcontent-%COMP%]{background:#f3f3f3;z-index:10;padding:25px 0;margin-top:0;width:100%;display:block;position:relative}"];
export { styles as styles };
